import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import { ACTIVE_GOAL_STATES } from "web_myplann/Goals/constants";
import {
	type CreateGoalRequestDTO,
	type DefaultListMetaDTO,
	type GoalDetailResponseDTO,
	type GoalListItemResponseDTO,
	postGoalV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useGoalCreateMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<GoalDetailResponseDTO, Error, CreateGoalRequestDTO>({
		mutationFn: processResponse(postGoalV2),
		onSuccess: (goal) => {
			const { id } = goal;
			if (id == null) {
				return;
			}
			queryClient.setQueryData<GoalDetailResponseDTO>(
				GoalsKeys.detail(id),
				goal,
			);
			queryClient.setQueryData<{
				data: GoalListItemResponseDTO[];
				meta: DefaultListMetaDTO;
			}>(GoalsKeys.list(ACTIVE_GOAL_STATES), (list) =>
				list
					? {
							data: [
								{ ...goal, id },
								...list.data.filter((item) => item.id !== id),
							],
							meta: { ...list.meta, totalCount: list.meta.totalCount + 1 },
						}
					: list,
			);
		},
	});
};
